import React, { Component } from 'react'
import update from 'immutability-helper'
import PropTypes from 'prop-types'

import classnames from 'classnames'

import { Droppable, Draggable } from 'react-beautiful-dnd'

import { getStageElementsByTypes } from '../../../functions'

import ListItem from './list-item'

class ListGroup extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showEmptyListItem: false,
      showDropdown: false
    }
  }

  matchGroupChildren(children, drumElements) {
    const onlyDrumElements = children.every(child => child.title !== undefined ? drumElements.includes(child.title) : true)
    let unusedDrumElements = [...drumElements]

    children.forEach(child => {
      const index = unusedDrumElements.indexOf(child.title)
      unusedDrumElements = (index !== -1) ? update(unusedDrumElements, {$splice: [[index, 1]]}) : unusedDrumElements
    })

    return onlyDrumElements && unusedDrumElements.length > 0
  }

  addDefaultDrumSet(item, children, drumElements) {
    let items = []
    let position = 0

    drumElements.forEach((element, index) => {
      const elementExists = children.map(child => child.title).includes(element)

      if (!elementExists) {
        position += 1

        items = update(items, {$push: [
          {
            class: 'instrument',
            group: this.props.group,
            type: 'drums',
            title: element,
            position: children.length+position,
            parent: item.id
          }
        ]})
      }
    })

    this.props.createRiderItems(null, items)
  }

  refuseDefaultDrumSet(item, params) {
    params = !params ? update(params, {$set: {}}) : params

    this.props.editRiderItem({
      id: item.id,
      params: update(params, {
        $merge: {hideGroupInitialization: true}
      })
    })
  }

  renderDropdown(item, children, drumElements, showGroupInitialization) {
    const { showDropdown } = this.state

    const className = classnames({
      'ui-dropdown': true,
      'ui-dropdown--active': showDropdown
    })

    return (
      <div className={className}>
        {showDropdown === true ? <div className="ui-dropdown-escape" onClick={() => this.setState({showDropdown: !showDropdown})} /> : null}

        <div className="ui-dropdown-handle" onClick={() => this.setState({showDropdown: !showDropdown})} />

        {
          showDropdown === true
          ? <ul className="ui-dropdown-content">
              {
                showGroupInitialization
                ? <li onClick={() => this.setState({showDropdown: false}, () => this.addDefaultDrumSet(item, children, drumElements))}>Add default drum set</li>
                : null
              }
              <li onClick={() => this.setState({showDropdown: false}, () => this.props.deleteRiderItem(item.id))}>Remove this instrument group</li>
            </ul>
          : null
        }
      </div>
    )
  }

  render() {
    const { view, columns, item, stageElements } = this.props
    const { children } = item
    let { params } = item

    const drumElements = ['Kick drum', 'Snare drum', 'Rack tom', 'Floor tom', 'OH L', 'OH R']
    const showGroupInitialization = this.matchGroupChildren(children, drumElements)
    const hideGroupInitialization = (params && params.hideGroupInitialization) || false

    return (
      <Draggable key={item.id} draggableId={item.id} isDragDisabled={!view.editable} type="instrument">
        {(provided, snapshot) => (
          <div className="list-group">
            <div className="list-group--draggable"
              ref={provided.innerRef}
              style={provided.draggableStyle} >
              <div className="list-group-head">
                {
                  view.editable
                  ? <div className="list-group-handle" {...provided.dragHandleProps} />
                  : null
                }

                {
                  view.editable
                  ? this.renderDropdown(item, children, drumElements, showGroupInitialization)
                  : null
                }

                <h3 className="list-group-title">{item.title}</h3>

                {
                  showGroupInitialization && !hideGroupInitialization && children.length > 0
                  ? <p className="group-initialization">
                      {`Add all default drum elements to this Drum set`}

                      <button className="button--success" onClick={() => this.addDefaultDrumSet(item, children, drumElements)}>Add</button>
                      <button className="button--default" onClick={() => this.refuseDefaultDrumSet(item, params)}>Hide</button>
                    </p>
                  : null
                }
              </div>

              <Droppable droppableId={item.id} isDropDisabled={!view.editable} type={this.props.dragDropType}>
                {(provided, snapshot) => (
                  <div className="list-group--droppable"
                    ref={provided.innerRef} >
                    {
                      children.length > 0
                      ? children.map((child, index) => {
                          return child.class === 'instrument'
                          ? <ListItem key={child.id || index}
                              view={view}
                              dragDropType={this.props.dragDropType}
                              group={this.props.group}
                              columns={columns}
                              item={child}
                              itemIndex={index}
                              parentItem={item}
                              parentItemIndex={this.props.itemIndex}
                              itemGroups={this.props.itemGroups}
                              position={child.position}
                              required={child.required}
                              setFocus={child.title ? false : true}
                              createRiderColumn={this.props.createRiderColumn}
                              addRiderItem={this.props.addRiderItem}
                              removeRiderItem={this.props.removeRiderItem}
                              createRiderItem={this.props.createRiderItem}
                              editRiderItem={this.props.editRiderItem}
                              deleteRiderItem={this.props.deleteRiderItem}
                              stageElements={stageElements}
                              options={[]}
                              categories={getStageElementsByTypes(['drums'], stageElements.groups && stageElements.groups.instrument && stageElements.groups.instrument.groups)}
                              createStageElement={this.props.createStageElement}
                              getSearchResults={this.props.getSearchResults} />
                          : null
                        })
                      : null
                    }

                    {provided.placeholder}
                  </div>
                )}
              </Droppable>

              {
                showGroupInitialization && !hideGroupInitialization && children.length === 0
                ? <p className="group-initialization">
                    {`You have created a ${item.title}.`}<br />
                    {`Start by typing in drum elements such as "Kick drum", "Snare drum" etc,`}<br />
                    {`or let us set up a default set for you`}

                    <button className="button--success" onClick={() => this.addDefaultDrumSet(item, children, drumElements)}>Set up</button>
                    <button className="button--default" onClick={() => this.refuseDefaultDrumSet(item, params)}>No thanks</button>
                  </p>
                : null
              }

              {
                view.editable
                ? <button className="list--add-button button--link" onClick={() => {
                    this.props.addRiderItem({
                      class: "instrument",
                      position: children.length+1,
                      parent: item.id || null,
                      type: item.type,
                      indexes: [
                        this.props.itemIndex,
                        children.length
                      ]
                    })
                  }}>
                    Insert instrument to {item.title}
                  </button>
                : null
              }
            </div>

            {provided.placeholder}
          </div>
        )}
      </Draggable>
    )
  }
}

ListGroup.propTypes = {
  view: PropTypes.object,
  dragDropType: PropTypes.string,
  group: PropTypes.string,
  columns: PropTypes.array,
  item: PropTypes.object,
  itemIndex: PropTypes.number,
  itemGroups: PropTypes.array,
  createRiderColumn: PropTypes.func,
  addRiderItem: PropTypes.func,
  removeRiderItem: PropTypes.func,
  createRiderItem: PropTypes.func,
  createRiderItems: PropTypes.func,
  editRiderItem: PropTypes.func,
  deleteRiderItem: PropTypes.func,
  stageElements: PropTypes.object,
  createStageElement: PropTypes.func,
  getSearchResults: PropTypes.func
}

ListGroup.defaultProps = {
  view: {},
  dragDropType: '',
  group: '',
  columns: [],
  item: {},
  itemIndex: undefined,
  itemGroups: [],
  createRiderColumn: function() {},
  addRiderItem: function() {},
  removeRiderItem: function() {},
  createRiderItem: function() {},
  createRiderItems: function() {},
  editRiderItem: function() {},
  deleteRiderItem: function() {},
  stageElements: {},
  createStageElement: function() {},
  getSearchResults: function() {}
}

export default ListGroup



// WEBPACK FOOTER //
// ./src/components/rider/rider-input/input-list/list-group.js